import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setERPJobImportLogsOperations = (state, { erpJobImportLogsOperationsData }) => {
  if (!erpJobImportLogsOperationsData) return state;
  return state.merge({ erpJobImportLogsOperationsData });
};

const setERPJobImportLogsOperationsLoaderStatus = (state, { erpJobImportLogsOperationsLoaderStatus }) => {
  return state.merge({ erpJobImportLogsOperationsLoaderStatus });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ERP_JOB_IMPORT_LOGS_OPERATION,
    actionFunction: setERPJobImportLogsOperations,
  },
  {
    actionType: ActionTypes.SET_ERP_JOB_IMPORT_LOGS_OPERATION_LOADER_STATUS,
    actionFunction: setERPJobImportLogsOperationsLoaderStatus,
  },
];
